import { atom } from "jotai/index";

import DaysServices from "utils/days";

import { TReportsFilter } from "../../types/reports";

const reportsFiltersAtom = atom<TReportsFilter, any, void>(
  {
    dateFrom: DaysServices.getDayStart(new Date()),
    dateTo: DaysServices.getDayEnd(new Date()),
    storeIds: [],
    itemGroupIds: [],
  },
  (get, set, update: TReportsFilter) => {
    set(reportsFiltersAtom, {
      ...get(reportsFiltersAtom),
      ...update,
    });
  }
);

const reportsAtom = atom<any[]>([]);
const reportsFilteredAtom = atom<any[]>([]);
const reportsHeadersAtom = atom<any[]>([]);

export {
  reportsFiltersAtom,
  reportsAtom,
  reportsHeadersAtom,
  reportsFilteredAtom,
};
